import React, { createContext, useState } from "react";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [msgNotification, setMsgNotification] = useState(null);

  return <NotificationContext.Provider value={{ msgNotification, setMsgNotification }}>{children}</NotificationContext.Provider>;
};
